import { Component, Input } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyManagerModule } from '../../study-manager.module';
import { JhiLanguageService } from '../../../shared/core-utils';

@Component({
    selector: 'jhi-advance-samples-modal',
    standalone: true,
    imports: [
        NgSelectModule,
        TranslateModule,
        StudyManagerModule
    ],
    templateUrl: './advance-samples-modal.component.html',
    styleUrl: './advance-samples-modal.component.scss'
})
export class AdvanceSamplesModalComponent {

    @Input() studyId: any;
    @Input() selectedInstances: any[];
    @Input() replicationNumber: number;

    constructor(
        private languageService: JhiLanguageService,
        private activeModal: NgbActiveModal) {}

    closeModal() {
        this.activeModal.dismiss();
    }
}
